import { GetAutoPayDetails } from '../contracts';
import axios from 'axios';
import { createAxiosConfig } from '../createAxiosConfig';
import CookieHelper from '../../utils/cookieHelper';
import StatusCode from 'status-code-enum';
import { ErrorType, IGetAutoPayDetailsRequest } from '../../shared/types';
import LogCannon from '@ace-clublabs/log-cannon';

export const GetAutoPayDetailsApi =
  (endpoint: string): GetAutoPayDetails =>
  async (request: IGetAutoPayDetailsRequest = {}) => {
    const { transactionId, brokerRegion } = request;

    try {
      let queryParams: string[] = [];
      if (transactionId) queryParams.push(`transactionId=${transactionId}`);
      if (brokerRegion) queryParams.push(`brokerRegion=${brokerRegion}`);
      const modifiedEndpoint = queryParams.length > 0 ? `${endpoint}?${queryParams.join('&')}` : endpoint;

      const scenario = CookieHelper.getCookie('scenario');
      LogCannon.blast('GetAutoPayDetailsApi scenario', scenario ? { scenario } : {});

      LogCannon.blast('GetAutoPayDetailsApi start', modifiedEndpoint ? { modifiedEndpoint } : {});
      const response = await axios.get(`${modifiedEndpoint}`, createAxiosConfig(scenario, endpoint));
      LogCannon.blast('GetAutoPayDetailsApi success');
      return Promise.resolve(response.data);
    } catch (error: any) {
      LogCannon.error('GetAutoPayDetailsApi error', { error: error?.message });
      if (error.response) {
        const statusCode = error.response.status;
        const errorMessage = error.response.data?.message || error?.message || error.response.data.error.message;
        if (statusCode === StatusCode.ClientErrorUnauthorized) {
          return Promise.reject({
            message: errorMessage,
            type: ErrorType.SESSION_TIMEOUT,
          });
        }

        if (statusCode === StatusCode.ClientErrorForbidden) {
          return Promise.reject({
            message: errorMessage,
            type: ErrorType.AUTH_ERROR,
          });
        }

        if (statusCode === StatusCode.ClientErrorPaymentRequired) {
          return Promise.reject({
            message: errorMessage,
            type: ErrorType.PROCESSING_ERROR,
          });
        }

        return Promise.reject({
          message: errorMessage,
          type: ErrorType.SYSTEM_ERROR,
        });
      }
      return Promise.reject({
        message: error,
      });
    }
  };
